import { useMemo } from 'react';

import { DataStorage, StorageData } from '@suntex.core/storage';

export function useSessionData<T extends StorageData>(): DataStorage<T> {
  const sessionDataStorage = useMemo(
    () => new DataStorage<T>(sessionStorage),
    [],
  );
  return sessionDataStorage;
}
